import { render, staticRenderFns } from "./cooperationByWhiteList.vue?vue&type=template&id=52280515&scoped=true"
import script from "./cooperationByWhiteList.vue?vue&type=script&lang=js"
export * from "./cooperationByWhiteList.vue?vue&type=script&lang=js"
import style0 from "./cooperationByWhiteList.vue?vue&type=style&index=0&id=52280515&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52280515",
  null
  
)

export default component.exports